export default __webpack_public_path__ + "static/media/books-22.24ca36e0.jpg";